/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React, { useEffect, useRef } from 'react';
import MonsterGrid from './MonsterGrid';
import searchImg from './dndimages/search.png';
import DataModel from './model/DataModel';
import Monster from './model/Monster';

interface MonsterSearchProps {
  isOpen: boolean;
  minCr: number | null;
  maxCr: number | null;
  keywords: string;
  selectedEnvironments: string[];
  pageSize: number | null;
  currentPage: number | null;
  sortBy: { id: string; desc: boolean }[];
  dataModel: DataModel;
  myMonsters: Monster[];
  onUpdateMinCr: (minCr: number) => void;
  onUpdateMaxCr: (maxCr: number) => void;
  onUpdateKeywords: (keywords: string) => void;
  onUpdateSelectedEnvironments: (environments: string[]) => void;
  onUpdatePageSize: (pageSize: number) => void;
  onUpdateCurrentPage: (currentPage: number) => void;
  onUpdateSort: (sortBy: { id: string; desc: boolean }[]) => void;
  setIsOpen: (isOpen: boolean) => void;
  handleMonsterChange: (monsterId: string) => void;
}

const MonsterSearch: React.FC<MonsterSearchProps> = ({isOpen, minCr, maxCr, selectedEnvironments, keywords, pageSize, currentPage, sortBy,
                                                      dataModel, myMonsters, onUpdateMinCr, onUpdateMaxCr, onUpdateKeywords, onUpdateSelectedEnvironments,
                                                      onUpdatePageSize, onUpdateCurrentPage, onUpdateSort, setIsOpen, handleMonsterChange }) => {
  const popupPanelRef = useRef<HTMLSpanElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      popupPanelRef.current &&
      !popupPanelRef.current.contains(event.target as Node) &&
      imageRef.current &&
      !imageRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <img
        src={searchImg}
        alt="Advanced Monster Search"
        style={{ width: '32px', cursor: 'pointer' }}
        onClick={() => setIsOpen(true)}
        ref={imageRef}
        id='monsterGridSearch'
      />
      {isOpen && (
        <span className="multi-select-container edit-field" id='AdvancedMonsterGrid'>
          <span className="monster-search-panel" ref={popupPanelRef}>
            <MonsterGrid onSelectMonster={monsterId => handleMonsterChange(monsterId)}
                         minCr={minCr} maxCr={maxCr} keywords={keywords} selectedEnvironments={selectedEnvironments}
                         pageSize={pageSize} currentPage={currentPage} sortBy={sortBy}
                         onUpdateMinCr={onUpdateMinCr} onUpdateMaxCr={onUpdateMaxCr} onUpdateKeywords={onUpdateKeywords}
                         onUpdateSelectedEnvironments={onUpdateSelectedEnvironments}
                         onUpdatePageSize={onUpdatePageSize} onUpdateCurrentPage={onUpdateCurrentPage}
                         onUpdateSort={onUpdateSort} dataModel={dataModel} myMonsters={myMonsters}
                       />
          </span>
        </span>
      )}
    </>
  );
};

export default MonsterSearch;
